export default {
  path: 'projects/create',
  name: 'project/create',
  component: () => import('@/views/dashboard/projects/create/create.vue'),
};
